// @flow
import { motion, useMotionValue, useSpring } from 'framer-motion';
import { window } from 'browser-monads';
import * as React from 'react';

import Footer from './footer';
import Header from './header';
import Seo from './seo';

type LayoutProps = { children: React.Element };

/* eslint-disable-next-line */
export function Layout({ children }: LayoutProps) {
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);

  const springConfig = { damping: 55, stiffness: 500 };
  const cursorXSpring = useSpring(cursorX, springConfig);
  const cursorYSpring = useSpring(cursorY, springConfig);

  React.useEffect(() => {
    const moveCursor = (e) => {
      cursorX.set(e.clientX);
      cursorY.set(e.clientY);
    };

    window.addEventListener('mousemove', moveCursor);

    return () => {
      window.removeEventListener('mousemove', moveCursor);
    };
  }, []);

  return (
    <>
      <motion.div
        className="motorx-cursor"
        whileHover={{ scale: 0.8 }}
        style={{
          translateX: cursorXSpring,
          translateY: cursorYSpring,
        }}
      />
      <Seo />
      <Header />
      <motion.main
        initial={{ opacity: 0, x: -200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 200 }}
        transition={{
          type: 'spring',
          mass: 0.35,
          stiffness: 75,
          duration: 0.3,
        }}
      >
        {children}
      </motion.main>
      <Footer />
    </>
  );
}
